module.exports = __webpack_public_path__ + "img/nctu-logo.1ca000c6.png";